var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.577 22.3691H7.753C4.312 22.3691 2 19.9541 2 16.3601V8.04611C2 4.45211 4.312 2.03711 7.753 2.03711H11.492C11.906 2.03711 12.242 2.37311 12.242 2.78711C12.242 3.20111 11.906 3.53711 11.492 3.53711H7.753C5.169 3.53711 3.5 5.30711 3.5 8.04611V16.3601C3.5 19.0991 5.169 20.8691 7.753 20.8691H16.577C19.161 20.8691 20.831 19.0991 20.831 16.3601V12.3321C20.831 11.9181 21.167 11.5821 21.581 11.5821C21.995 11.5821 22.331 11.9181 22.331 12.3321V16.3601C22.331 19.9541 20.018 22.3691 16.577 22.3691Z",
    fill: "#353535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86762 15.4285H11.8446C12.2246 15.4285 12.5806 15.2815 12.8496 15.0125L20.3586 7.50349C20.6666 7.19549 20.8366 6.78549 20.8366 6.34949C20.8366 5.91249 20.6666 5.50149 20.3586 5.19349L19.1416 3.97649C18.5046 3.34149 17.4686 3.34149 16.8306 3.97649L9.35762 11.4495C9.09862 11.7085 8.95162 12.0525 8.94262 12.4175L8.86762 15.4285ZM11.8446 16.9285H8.09862C7.89662 16.9285 7.70262 16.8465 7.56162 16.7015C7.42062 16.5575 7.34362 16.3625 7.34862 16.1595L7.44262 12.3805C7.46162 11.6285 7.76462 10.9215 8.29662 10.3885H8.29762L15.7706 2.91549C16.9926 1.69549 18.9796 1.69549 20.2016 2.91549L21.4186 4.13249C22.0116 4.72449 22.3376 5.51149 22.3366 6.34949C22.3366 7.18749 22.0106 7.97349 21.4186 8.56449L13.9096 16.0735C13.3586 16.6245 12.6246 16.9285 11.8446 16.9285Z",
    fill: "#353535"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7308 9.91685C19.5388 9.91685 19.3468 9.84385 19.2008 9.69685L14.6348 5.13085C14.3418 4.83785 14.3418 4.36285 14.6348 4.06985C14.9278 3.77685 15.4018 3.77685 15.6948 4.06985L20.2608 8.63685C20.5538 8.92985 20.5538 9.40385 20.2608 9.69685C20.1148 9.84385 19.9228 9.91685 19.7308 9.91685Z",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditimg);
export default __webpack_public_path__ + "static/media/Edit img.02ad294418860f05fab8a58b421fbe41.svg";
export { ForwardRef as ReactComponent };